export const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'tiff', 'bmp']

export const fileExtension = (filename: string) => {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)
}
